// @flow
/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { Avatar, GridLayout, Text } from '@zapier/common-components';

import type { TeamMemberType } from '@zapier/team/src/types';

type Props = {
  /** Team Member */
  item: TeamMemberType,
};

const ZapOwnerMenuItem = ({ item }: Props) => {
  return (
    <GridLayout alignItems="center" columns="40px 1fr" gap={5}>
      <Avatar name={item.name || item.email} url={item.avatarUrl} />
      <GridLayout>
        <Text color="deepSpace" type="body">
          {item.name}
        </Text>
        <Text color="batmobile" type="body">
          {item.email}
        </Text>
      </GridLayout>
    </GridLayout>
  );
};

export default ZapOwnerMenuItem;
